/* eslint-disable max-len */
import React,{useState,useEffect,memo} from 'react'

const StatusBar=({handleFilters,status, statusBarList})=> {    
    return (
        <div class="border border-[#d0d5dd] rounded p-[5px] h-fit" style={{'padding':'3px'}}>
            {statusBarList?.map((statusItem, index) => (
                <button
                    key={index}
                    id={statusItem}
                    onClick={() => handleFilters('status', statusItem.toLowerCase())} 
                    className={`px-2 py-1 rounded text-base font-normal ${(status === statusItem.toLowerCase()) ? 'bg-[#106EB4] text-[#ffffff]' : 'text-[#106eb4]'
                    }`}
                >
                    {statusItem} 
                </button>
            ))}

            {/* <button
                id="All"
                onClick={() => handleFilters('all', true)}
                className={`px-2 py-1 rounded text-base font-normal ${status === null ? 'text-[#ffffff] bg-[#106EB4]' : 'text-[#106eb4]'}`}
            >
                All
            </button> */}
            
        </div>
    )
}
export default StatusBar

